import script from "./QSelectSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./QSelectSearch.vue?vue&type=script&setup=true&lang=ts"

import "./QSelectSearch.vue?vue&type=style&index=0&id=4a222550&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a222550"]])

export default __exports__